(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  document.querySelectorAll('.pdp').forEach((pdp) => {
    // Image gallery: swap the main image when a thumbnail is clicked
    const mainImg = pdp.querySelector('[data-pdp-main]');
    const thumbs = pdp.querySelectorAll('[data-pdp-thumb]');
    if (mainImg && thumbs.length) {
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          mainImg.src = thumb.dataset.full;
          if (thumb.dataset.srcset) mainImg.srcset = thumb.dataset.srcset;
          if (thumb.dataset.alt) mainImg.alt = thumb.dataset.alt;
          thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        });
      });
    }

    const form = pdp.querySelector('.pdp__form');
    if (!form) return;
    const idInput = form.querySelector('[data-variant-id]');
    const selects = form.querySelectorAll('.pdp__variant-select');
    const priceEl = pdp.querySelector('[data-price]');
    const addBtn = form.querySelector('.pdp__add');
    let variants = [];
    try {
      variants = JSON.parse(pdp.dataset.variants || '[]');
    } catch (e) {
      variants = [];
    }
    if (!selects.length || !variants.length) return;

    function update() {
      const chosen = Array.from(selects).map((s) => s.value);
      const match = variants.find((v) => chosen.every((val, i) => v.options[i] === val));
      if (!match) return;
      idInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Add to cart' : 'Sold out';
      }
    }
    selects.forEach((s) => s.addEventListener('change', update));
  });

  } catch(e) { console.error(e); }
})();
})();
